<template>
  <div class="dashboard-bookings-calendar">
    <Calendar
      class="dashboard-bookings-calendar__calendar"
      :masks="masks"
      :attributes="attributes"
      disable-page-swipe
      is-expanded
      @update:to-page="fetchBookings"
    >
      <template v-slot:day-content="{ day, attributes }">
        <CalendarDate :day="day" :attributes="attributes" />
      </template>
    </Calendar>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import CalendarDate from "./CalendarDate.vue";

export default {
  name: "BookingsCalendar",
  components: { CalendarDate },
  data() {
    const date = moment();

    return {
      bookings: [],
      masks: {
        weekdays: "WWW",
      },
      date
    };
  },
  methods: {
      async fetchBookings(dateObject) {
          if (!!dateObject) {
              const { month, year } = dateObject;

              this.date.set('date', 1);
              this.date.set('month', month);
              this.date.set('year', year);
          }

          const query = new URLSearchParams();
          query.append('month', this.date.month());
          query.append('year', this.date.year());

          const { data: { data: bookings } } = await axios.get(
              `/admin/api/bookings-calendar?${query.toString()}`
          );

          this.bookings = bookings;
      },
  },
  computed: {
    attributes() {
      return this.bookings.map((booking, index) => ({
        key: index,
        customData: {
          booking,
        },
        dates: moment(booking.start_date).toDate(),
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-bookings-calendar {
  ::v-deep .dashboard-bookings-calendar__calendar.vc-container {
    --day-border: 1px solid #b8c2cc;
    --day-border-highlight: 1px solid #b8c2cc;
    --day-width: 90px;
    --day-height: 90px;
    --weekday-bg: #f8fafc;
    --weekday-border: 1px solid #eaeaea;

    border-radius: 0;
    width: 100%;

    & .vc-header {
      background-color: #f1f5f8;
      padding: 10px 0;
    }
    & .vc-weeks {
      padding: 0;
    }
    & .vc-weekday {
      background-color: var(--weekday-bg);
      border-bottom: var(--weekday-border);
      border-top: var(--weekday-border);
      padding: 5px 0;
    }
    & .vc-day {
      overflow-x: visible;
      overflow-y: visible;
      padding: 0 5px 3px 5px;
      text-align: left;
      height: var(--day-height);
      min-width: var(--day-width);
      background-color: white;
      z-index: auto;

      &.weekday-1,
      &.weekday-7 {
        background-color: #eff8ff;

        .dashboard-bookings-calendar-item__date {
          background-color: #eff8ff;
        }
      }

      &:not(.on-bottom) {
        border-bottom: var(--day-border);
        &.weekday-1 {
          border-bottom: var(--day-border-highlight);
        }
      }

      &:not(.on-right) {
        border-right: var(--day-border);
      }
    }

    & .vc-day-dots {
      margin-bottom: 5px;
    }
  }
}
</style>
